import React from "react";
import ShoppingListItem from "./ShoppingListItem";
import CategoryList from "./CategoryList.js"
import {setItemTick,removeIngredient, renameIngredient, addMealIngredient} from "../service.js";
import {mergeIngredients} from "../dedupe.js";

export default function List({mealsFromServer,updateMealsFromServer,plan}){
  //dedupe in-scope meal ingredients into the shopping list (shared with the stock view)
  let ingredientList = mergeIngredients(mealsFromServer)

  function handleDelete(i){
    updateMealsFromServer(prevMealList => {
      const meal_ingredient_id = ingredientList[i].fromMeal.filter((ingredient) => ingredient.id === "0")[0].meal_ingredient_id
      const newMealList = prevMealList.map((meal)=> {
        if(meal.id === "0"){
          return {...meal, ingredients: meal.ingredients.filter((ingredient) => ingredient.id !== meal_ingredient_id)}
        }
        else{
          return meal
        }
      })
      //tell the server we want to delete this, it's only valid to do this for the hidden list
      removeIngredient("0",meal_ingredient_id)
      return newMealList
    })
  }

  function handleTick(i){
    console.log(i)
    updateMealsFromServer(prevMealList => {
      const meals_with_ingredient = ingredientList[i].fromMeal.map((mealWithIngredient) => mealWithIngredient.id)
      const newMealList = prevMealList.map((meal)=> {
        if(meals_with_ingredient.includes(meal.id)){
          return {...meal, ingredients: meal.ingredients.map((ingredient) => ingredient.label === ingredientList[i].label ? {...ingredient,ticked:!ingredientList[i].ticked}:ingredient)}
        }
        else{
          return meal
        }
        }
      )

      //toggle tick status
      setItemTick(ingredientList[i].fromMeal[0].id,ingredientList[i].id,!ingredientList[i].ticked)
      return newMealList
    })
  }

  function handleEdit(event,i,setEditMode){
    if (event.key === "Enter") {
      console.log(`Edit action on ${i}`)
      //force empty strings to be single space characters
      let newName = event.target.value === "" ? " " : event.target.value
      setEditMode(false)
      updateMealsFromServer((prevMealList) => {
        const meal_ingredient_id = ingredientList[i].fromMeal.filter((ingredient) => ingredient.id === "0")[0].meal_ingredient_id
        const newMealList = prevMealList.map((meal)=> {
          if(meal.id === "0"){
            console.log(`found ingredient ${meal_ingredient_id} in extras list`)
            console.log(meal)
            return {
              ...meal, 
              ingredients: meal.ingredients.map((ingredient) => {
                return {
                  ...ingredient,
                  label : meal_ingredient_id === ingredient.id ? newName : ingredient.label
                }
              })
            }
          }
          else{
            return meal
          }
        })
        renameIngredient("0",meal_ingredient_id,newName)
        return newMealList
      }
      )
    }
  }

  function addItem(){
    // Update UI
    updateMealsFromServer((prevMealList) => {
      const newMealList = prevMealList.map((meal)=> {
        if(meal.id === "0"){
          return {
            ...meal,ingredients : 
              [{
                ticked:false,
                label:"new",
                category: 0,
                fromMeal:[]
              },...meal.ingredients]
          }
        }
        else{
          return meal
        }
      })
      return newMealList
    }
    )
    // Update UUID when Server responds
    addMealIngredient("0","new").then((data) =>
      updateMealsFromServer((prevMeals) => {
        const newMealList = prevMeals.map((meal) => 
          {
            return meal.id !== "0" ? meal : {...meal, ingredients: meal.ingredients.map((ingredient) =>
            {
              return {...ingredient, id : ingredient.id === undefined ? data.id : ingredient.id}
            }
          )}
        })
        return newMealList
      })
    )
  }
  return(
    <div className="list">
      <button className="listItem--button" onClick={addItem}>
        +
      </button>
      {
        ["Tat","Toiletries","Fruit and Veg","Dairy","Cleaning and Birds","Cooked Meat","Ready Meals, Chicken","Frozen","Meat++","Condiments and Cans","World Food","Snacks + Chocolate","Tea/Coffee","Staples","Bakery","Drinks"].map((name,i) => {
          return (<CategoryList key={i}
          index={i}
          categoryName={name}
          categoryIngredientList={ingredientList.map((ingredient,original_index) => ingredient.category === i ? {...ingredient, oi : original_index} : null).filter((item) => item !== null)}
          handleTick={handleTick}
          updateMealsFromServer={updateMealsFromServer}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          plan={plan}
        />)
        })
      }
      <div className="list--ticked">
      {
        ingredientList.map(
          (li,i) => ( li.ticked) ?
          <ShoppingListItem key={i}
          originalIndex={i}
          checked={true}
          stocked={li.stocked}
          label={li.label}
          fromMeal={li.fromMeal}
          handleTick={handleTick}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          justMade={false}
          plan={plan}
          /> : null
        )
      }
      </div>
    </div>
  )
}